<template lang="pug">
  div
    div( class="btn-group" )
      MModalButton(
        v-bind:button-text="'Whitelist this Advertiser'"
        title="Help this Advertiser to whitelist Moonpull"
        button-classes="small"
        modal-size="modal-lg"
      )
        div( slot="body" )
          div
           div( class="styled-paragraph" )
            span This advertiser's results would be improved by the advertiser 'whitelisting' the Moonpull service. 
            span This will allow Moonpull to audit the advertiser unimpeded by any security software
            span the advertiser uses.
            br
            span Please would you provide contact details for a relevant person/department at the advertiser.
            span Moonpull will contact the advertiser with our IP details for them to implement the whitelisting.
            span We will confirm to the advertiser your details - and copy you in - on the request we send.

            MModalButton(
              v-bind:button-text="'Start whitelisting process'"
              title="Start whitelisting"
              button-classes="btn btn-primary mt-2"
              modal-size="modal-lg"
            )
              div( slot="body" )
                MForm( v-on:submit="createWhitelistRequest" submit-text="Send")
                  h2( class="text-left" ) My Details
                  MInput(
                    name="name"
                    label="Name"
                    type="text"
                    v-bind:value="($moonpull.getCurrentUserSession().name)"
                  )
                  MInput(
                    name="useremail"
                    label="Email"
                    type="text"
                    v-bind:value="($moonpull.getCurrentUserSession().email)"
                  )
                  MInput(
                    name="company"
                    label="Company"
                    type="text"
                    v-bind:value="($moonpull.getCurrentUserSession().company.name)"
                  )
                  MInput(
                    name="advertiser"
                    label="Advertiser"
                    type="text"
                    v-bind:value="(audit.advertiser.name)"
                    disabled
                  )
                  MInput(
                    name="auditId"
                    type="hidden"
                    v-bind:value="(audit.id)"
                  )
                  MInput(
                    name="advertiserId"
                    type="hidden"
                    v-bind:value="(audit.advertiser.id)"
                  )
                  hr
                  h2( class="text-left" )  Advertiser Contact Information
                  MInput(
                    name="recipientName"
                    label="Name"
                    type="text"
                    required
                  )

                  MInput(
                    name="recipientEmail"
                    label="Email"
                    type="text"
                    required
                  )
                  span( class="text-left" ) Additional details you'd like us to know and/or to pass onto the advertiser.
                  MInput(
                    name="message"
                    label="Details"
                    type="textarea"
                  )

  
</template>
<style scoped>
  .styled-paragraph {
    margin: 20px; /* Adds some space around the paragraph */
    font-family: Arial, sans-serif; /* Sets a readable font */
    font-size: 16px; /* Sets a comfortable font size */
    line-height: 1.6; /* Sets a line height for better readability */
  }
  .styled-paragraph span {
    display: block; /* Makes each span a block element, creating line breaks */
  }
</style>

<script>
import Moonpull from '@/plugins/moonpull/Moonpull'
import gql from 'graphql-tag'
import Vue from 'vue'
export default Vue.extend({

  methods: {
    createWhitelistRequest(data) {
      this.$apollo.mutate({
        mutation: gql`
          mutation whitelistingRequestCreate($record: WhitelistingRequestNewInput!) {
            whitelistingRequestCreate(record: $record) {
              id
            }
          }
        `,
        variables: {
          record: {
            advertiserId: data.advertiserId,
            userId: this.$moonpull.getCurrentUserSession().id,
            technicalContact: data.recipientName,
            technicalContactEmail: data.recipientEmail,
            auditId: data.auditId,
            whitelistSent: false,
            whitelistSentDate: null,
            datacenterIds: null,
            whitelistConfirmed: false,
            whitelistActive: false,
            message: data.message,
            moonpullComment: null,
          }
        }
      }).then(() => {
        this.sendMailSuccessful = true
      })
      this.$emit('dismissModals')
      this.$store.dispatch('flashMessage', { type: 'success', msg: 'Whitelist creation successful' })
    }
  },
  props: {
    audit: {
      type: Object,
      required: true
    }
  },
})
</script>